package services.storage

import it.neckar.lizergy.model.company.UsersAndCompanies
import it.neckar.lizergy.model.price.AvailableProducts
import it.neckar.lizergy.model.price.PriceList
import it.neckar.lizergy.model.price.ProductResolver
import it.neckar.rest.RestResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Response for
 */
@Serializable
sealed interface LoadEssentialsResponse : RestResponse<LoadedEssentials> {

  @Serializable
  @SerialName("good")
  data class Good internal constructor(override val data: LoadedEssentials) : LoadEssentialsResponse, RestResponse.GoodResponse<LoadedEssentials>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : LoadEssentialsResponse, RestResponse.BadResponse<LoadedEssentials>

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: LoadedEssentials): LoadEssentialsResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(): LoadEssentialsResponse = Failed

    /**
     * Creates a success method for non-null results, failure for null results
     */
    fun createFor(data: LoadedEssentials?): LoadEssentialsResponse {
      return if (data != null) {
        good(data)
      } else {
        bad()
      }
    }
  }
}

@Serializable
data class LoadedEssentials(
  val usersAndCompanies: UsersAndCompanies,
  val availableProducts: AvailableProducts,
  val productResolver: ProductResolver,
  val priceList: PriceList,
)
